module.exports = require("./de-BE.js");